import CISLoginButton from '../../../public/CIS2_LogInWith_Original.svg';

interface SPIInformationProps {
    onLogin: () => void;
}

function SPIInformation({ onLogin }: SPIInformationProps) {
  return (
    <>
      <h1 className="nhsuk-heading-l" data-testid="landing-page-title">
        Select People For Invitation (SPI)
      </h1>

      <p
        className="landing-page__text--bold"
        data-testid="landing-page-intro"
      >
        You can use this service to create campaigns to invite people to
        book an appointment or make them aware of an NHS service.
      </p>
      <ul
        data-testid="landing-page-features"
        aria-label="SPI service features"
      >
        <li>Create, edit or view a campaign.</li>
        <li>
          Easily select standard business rules from a library, for
          example, excluding care home residents or only including
          people in a particular postcode.
        </li>
        <li>View previous campaigns for audit purposes.</li>
      </ul>

      <p
        className="landing-page__text--bold"
        data-testid="landing-page-tagline"
      >
        SPI helps to ensure you invite the right person, at the right
        time, with the right invitation.
      </p>

      <button
        onClick={onLogin}
        className="landing-page__cis2-button"
        data-testid="landing-page-login-button"
        aria-label="Login with CIS"
        type="button"
      >
        <img
          src={CISLoginButton as string}
          alt="Login with CIS"
        />
      </button>
    </>
  );
}

export default SPIInformation;
